import { render, staticRenderFns } from "./Lojas.vue?vue&type=template&id=4c19b731"
import script from "../controllers/Lojas.ts?vue&type=script&lang=ts&external"
export * from "../controllers/Lojas.ts?vue&type=script&lang=ts&external"
import style0 from "./Lojas.vue?vue&type=style&index=0&id=4c19b731&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports